import React from 'react';
import { SILOS } from '../../data/blog/silos';
import type { SiloId } from '../../types/blog';

interface SiloBadgeProps {
  silo: SiloId;
  size?: 'sm' | 'md';
}

const SiloBadge: React.FC<SiloBadgeProps> = ({ silo, size = 'sm' }) => {
  const siloData = SILOS[silo];
  const sizeClasses = size === 'md' ? 'px-3 py-1.5 text-[12px]' : 'px-2.5 py-1 text-[11px]';

  return (
    <span
      className={`inline-flex items-center rounded-full border border-accent/40 bg-accent/10 label-mono !leading-none text-accent-soft ${sizeClasses}`}
    >
      {siloData.title}
    </span>
  );
};

export default SiloBadge;
